export default __webpack_public_path__ + "locales/el-GR/Settings.json?hash=7209d0bc8d835eee4eab70e9b43a74f0";